---
label: Creating
category: sequences
icon: PencilIcon
keywords: [create, new, sequence, fasta, accession, genbank, ncbi, import]
addedInVersion: "0.0.0"
---

# Creating Sequences

Create new sequences in Gnomux.

More documentation coming soon.
